import { CampaignsIcon } from '@va/icons';
import { useTranslate } from '@va/localization';
import { Paragraph, paragraphSizes } from '@va/ui/design-system';
import { TooltipWrapper } from '@va/ui/tooltips';
import { useMemo } from 'react';

type CampaignDetailType = {
  campaignDetails: {
    adCampaignKey: string | null;
    adCampaignSource: string | null;
    adCampaignMedium: string | null;
    adCampaignTerm: string | null;
    adCampaignContent: string | null;
    adCampaignLabel: string | null;
  };
};

export const CampaignDetail = ({ campaignDetails }: CampaignDetailType) => {
  const { adCampaignKey, adCampaignSource, adCampaignMedium, adCampaignTerm, adCampaignContent, adCampaignLabel } =
    campaignDetails;

  const translate = useTranslate();

  const tooltipContent = useMemo(() => {
    return (
      <div className='flex flex-col'>
        <Paragraph size={paragraphSizes.normal}>
          {translate('visitorHistory.campaignName')}: {adCampaignLabel}
        </Paragraph>
        <Paragraph size={paragraphSizes.tiny}>
          {translate('visitorHistory.campaignSource')}: {adCampaignSource}
        </Paragraph>
        <Paragraph size={paragraphSizes.tiny}>
          {translate('visitorHistory.campaignMedium')}: {adCampaignMedium}
        </Paragraph>
        <Paragraph size={paragraphSizes.tiny}>
          {translate('visitorHistory.campaignTerm')}: {adCampaignTerm}
        </Paragraph>
        <Paragraph size={paragraphSizes.tiny}>
          {translate('visitorHistory.campaignContent')}: {adCampaignContent}
        </Paragraph>
      </div>
    );
  }, [translate, adCampaignLabel, adCampaignSource, adCampaignMedium, adCampaignTerm, adCampaignContent]);

  return (
    <TooltipWrapper content={adCampaignKey ? tooltipContent : translate('visitorsHistory.campaignInfo.noInfo')}>
      <div className='h-12 w-12 shrink-0 rounded-full bg-white-snow group-hover:bg-white hover:bg-white flex justify-center items-center'>
        <div className='shrink-0'>
          <CampaignsIcon color={adCampaignKey ? '#696969' : '#C3C3C3'} />
        </div>
      </div>
    </TooltipWrapper>
  );
};
